function _inspectType2EntityName(type) {
    switch (type) {
        case "1":
            return "mintalMesInventoryInputOutput";
        case "2":
            return "";
        case "3":
            return "mintalMesPrdProductionResult";
        case "4":
        case "5":
            return "mintalMesPrdSmeltingSlagIron";
        case "6":
            return "mintalMesPrdIronOutput";
        default:
            return;
    }
}

export {
    _inspectType2EntityName
}